import createEntityChangementConfig2 from '@infrastructure/entityChangement/createEntityChangementConfig2'
import queryClient from '@infrastructure/reactQuery/queryClient'

import { keys } from '../reactQuery'
import { intervalName, name, recommendationName, todoName } from '../repository'

createEntityChangementConfig2({
  entity: name,
  config: [
    {
      changements: [
        'created',
        'updated',
        'deleted',
        'recommendationsReordered'
      ],
      listener: () => {
        queryClient.invalidateQueries({
          queryKey: keys.lists()
        })
      }
    }
  ],
  dependenciesConfig: [
    {
      entities: [recommendationName, todoName, intervalName],
      changements: ['created', 'updated', 'deleted', 'intervalsReordered'],
      listener: () => {
        queryClient.invalidateQueries({
          queryKey: keys.lists()
        })
      }
    }
  ]
}).init()
